// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"4396e2b8d480d50ecc02","243":"307c1cf31df043fbcfea","595":"f7776ac79a7da92f941a","658":"ae1c2a4efb7cd6e98f77","871":"4273c13586548cc5a564"}[chunkId] + ".bundle.js";
};